import app from 'flarum/forum/app';
import Model from 'flarum/common/Model';
import User from 'flarum/common/models/User';
import Forum from 'flarum/common/models/Forum';
import Discussion from 'flarum/common/models/Discussion';
import Post from 'flarum/common/models/Post';
import computed from 'flarum/common/utils/computed';
import Album from './models/Album';
import Picture from './models/Picture';
import PrivatePicture from './models/PrivatePicture';

export default function () {
    app.store.models['cimaise-albums'] = Album;
    app.store.models['cimaise-pictures'] = Picture;
    app.store.models['cimaise-private-pictures'] = PrivatePicture;

    User.prototype.cimaiseAlbumCount = Model.attribute<number>('cimaiseAlbumCount');
    User.prototype.cimaisePictureCount = Model.attribute<number>('cimaisePictureCount');

    Forum.prototype.cimaiseCanView = Model.attribute<boolean>('cimaiseCanView');
    Forum.prototype.cimaiseCanCreatePersonalAlbums = Model.attribute<boolean>('cimaiseCanCreatePersonalAlbums');
    Forum.prototype.cimaiseCanCreateCommunityAlbums = Model.attribute<boolean>('cimaiseCanCreateCommunityAlbums');
    Forum.prototype.cimaiseCanCreateAlbums = computed<boolean>('cimaiseCanCreatePersonalAlbums', 'cimaiseCanCreateCommunityAlbums', (personal: any, community: any) => personal || community);

    Discussion.prototype.cimaiseAlbum = Model.hasOne<Album>('cimaiseAlbum');

    Post.prototype.cimaisePictures = Model.hasMany<Picture | PrivatePicture>('cimaisePictures');
}
